<app-textile-data-overview
  iconForCard="machine-quality-blue"
  [listOfTextileData]="listOfWeaveProducts"
  [columnDefs]="getColumnDefsForListOfWeaveProducts()"
  [textileDataService]="weaveProducts"
  [textileDataType]="textileDataType.WEAVE_PRODUCT"
  [gridIdentifier]="GRID_IDENTIFIER"
  (showOnlyLatestVersionChanged)="showOnlyLatestVersionChanged($event)"
  [showSearchBar]="false"
></app-textile-data-overview>
